module.exports = __webpack_public_path__ + "media/sewerz.a2374eaa.mp3";